import { useState } from 'react';
import { login } from '../api/auth';
import { LoginRequest } from '../types/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { encryptPassword } from '../utils/passwordEncryption';
import StorefrontLayout from '../components/StorefrontLayout';
import styles from '../styles/AuthPage.module.css';

export default function Login() {
  const [form, setForm] = useState<LoginRequest>({ email: '', password: '' });
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { setAccessToken } = useAuth();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    let failedAt = 'password encryption';
    try {
      const encryptedPassword = await encryptPassword(form.password ?? '');
      failedAt = 'login API request';
      const response = await login({ ...form, password: encryptedPassword });
      // store access token in memory only
      if (response.data?.accessToken) setAccessToken(response.data.accessToken);
      navigate('/dashboard');
    } catch (err: any) {
      console.error('Login submission failed:', {
        failedAt,
        name: err instanceof Error ? err.name : typeof err,
        message: err instanceof Error ? err.message : 'Unknown error',
        status: err.response?.status,
        url: err.config?.url,
      });
      const data = err.response?.data;
      if (data?.errors && typeof data.errors === 'object') {
        const messages = Object.values(data.errors).flat().filter(Boolean) as string[];
        setError(messages.join('\n'));
      } else if (data?.title) {
        setError(data.title);
      } else {
        setError(err.response?.data?.message || 'Login failed');
      }
    }
  };

 
return (
  <StorefrontLayout>
    <main className={styles.authMain}>
      <section className={styles.imagePanel} aria-label="Luma beauty story">
        <img src="https://images.unsplash.com/photo-1596462502278-27bfdc403348?auto=format&fit=crop&w=1100&q=85" alt="Makeup brushes and cosmetics" />
        <div className={styles.imageCopy}><span className={styles.imageKicker}>The everyday edit</span><h1>Beauty that<br /><em>feels like you.</em></h1><p>Thoughtfully chosen essentials for your most luminous self.</p></div>
      </section>
      <section className={styles.formPanel}>
        <form onSubmit={handleSubmit} className={styles.formContainer}>
          <span className={styles.formKicker}>Welcome back</span>
          <h2>Sign in</h2>
          <p className={styles.formIntro}>Pick up where your beauty ritual left off.</p>
          <label className={styles.field}>Email address<input name="email" type="email" autoComplete="email" onChange={handleChange} required /></label>
          <label className={styles.field}>Password<input name="password" type="password" autoComplete="current-password" onChange={handleChange} required /></label>
          <button type="submit" className={styles.submitButton}>Login to your account</button>
          <button type="button" className={styles.switchButton} onClick={() => navigate('/register')}>New to Luma? <strong>Create an account</strong></button>
          {error && <p className={styles.error} role="alert">{error}</p>}
        </form>
      </section>
    </main>
  </StorefrontLayout>
);

}
